import { FilterConfig } from '../../../components/Tables/advancedRecord/FilterBar';

/**
 * Construye la configuración de filtros
 * para la gestión de stock de inventario
 * siguiendo el mismo patrón visual de AdvancedRecordTable
 */
export const buildInventoryStockFilters = (
  branchDropdown: { id: number; name: string }[],
  productDropdown: { id: number; name: string }[],
  categoryDropdown: { id: number; name: string }[],
  unitDropdown: { id: number; name: string }[]
): FilterConfig[] => [
  /**
   * 🏢 Sucursal
   */
  {
    name: 'branchId',
    label: 'Sucursal',
    type: 'searchSelect',
    options: branchDropdown.map((b) => ({
      id: b.id,
      name: b.name,
    })),
    colSpan: 3,
  },

  /**
   * 📦 Producto
   */
  {
    name: 'productId',
    label: 'Producto',
    type: 'searchSelect',
    options: productDropdown.map((p) => ({
      id: p.id,
      name: p.name,
    })),
    colSpan: 3,
  },

  /**
   * 🗂️ Categoría
   */
  {
    name: 'categoryId',
    label: 'Categoría',
    type: 'searchSelect',
    options: categoryDropdown.map((c) => ({
      id: c.id,
      name: c.name,
    })),
    colSpan: 3,
  },

  /**
   * 📏 Unidad de medida
   */
  {
    name: 'unitId',
    label: 'Unidad de Medida',
    type: 'searchSelect',
    options: unitDropdown.map((u) => ({
      id: u.id,
      name: u.name,
    })),
    colSpan: 3,
  },

  /**
   * 📉 Existencias mínimas
   */
  {
    name: 'minStockQuantity',
    label: 'Existencias mínimas',
    type: 'number',
    colSpan: 3,
  },

  /**
   * 📈 Existencias máximas
   */
  {
    name: 'maxStockQuantity',
    label: 'Existencias máximas',
    type: 'number',
    colSpan: 3,
  },

  /**
   * 💰 Costo promedio mínimo
   */
  {
    name: 'minAverageCost',
    label: 'Costo promedio mínimo',
    type: 'number',
    colSpan: 3,
  },

  /**
   * 💰 Costo promedio máximo
   */
  {
    name: 'maxAverageCost',
    label: 'Costo promedio máximo',
    type: 'number',
    colSpan: 3,
  },
];
